"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoggingMessage = void 0;
const ProAdvertiseMessage_1 = require("../../constants/ProAdvertiseMessage");
var LoggingMessage;
(function (LoggingMessage) {
    LoggingMessage["EmptySourceCode"] = "Empty source code. Obfuscation canceled...";
    LoggingMessage["ObfuscationCompleted"] = "Obfuscation completed. Total time: %s sec.";
    LoggingMessage["ObfuscationStarted"] = "Obfuscation started...";
    LoggingMessage["RandomGeneratorSeed"] = "Random generator seed: %s...";
    LoggingMessage["CodeTransformationStage"] = "Code transformation stage: %s...";
    LoggingMessage["NodeTransformationStage"] = "AST transformation stage: %s...";
    LoggingMessage["Version"] = "Version: %s";
    LoggingMessage[LoggingMessage["JavaScriptObfuscatorProAdFirstPart"] = ProAdvertiseMessage_1.proAdvertiseMessageFirstPart] = "JavaScriptObfuscatorProAdFirstPart";
    LoggingMessage[LoggingMessage["JavaScriptObfuscatorProAdSecondPart"] = ProAdvertiseMessage_1.proAdvertiseMessageSecondPart] = "JavaScriptObfuscatorProAdSecondPart";
})(LoggingMessage || (exports.LoggingMessage = LoggingMessage = {}));
